var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('p',{staticClass:"title"},[_vm._v("About")]),_c('div',{staticClass:"text"},[_c('ui-text',{attrs:{"text":_vm.logged_user.role.about_you}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }